import { api } from "../AxiosInstance";
import { urlQueryBuilder } from "../utils/urlQueryBuilder";

const SearchService = {
  searchJobsOrContainers: async (
    queryParams: {
      status?: string;
      skip?: number;
      limit?: number;
      search?: string;
    } = {}
  ) => {
    try {
      const queryString = urlQueryBuilder(queryParams);
      const response = await api.get(
        `/job/search${queryString ? `?${queryString}` : ""}`
      );
      return response;
    } catch (error) {
      console.error("Error getMyJobs:", error);
      throw error; // Re-throw error for global handling if necessary
    }
  },
};

export default SearchService;
